import React, { FunctionComponent, ReactElement } from 'react'
import FlexingContainer from '../Layouts/FlexingContainer'
import Caption, { CaptionProps } from './Indicators/Caption/Caption'
import CaptionWithButton, { CaptionWithButtonProps } from './Indicators/Caption/CaptionWithButton'
import LoadingSpinner from './Indicators/LoadingSpinner'
import SplashScreenBackground, { SplashScreenBackgroundImageProps } from './Background'

export type SplashScreenProps = SplashScreenBackgroundImageProps &
    (CaptionProps | CaptionWithButtonProps | { showLoadingIndicator: boolean })

const IndicatorComponent: FunctionComponent<SplashScreenProps> = (props): ReactElement => {
    if ('caption' in props) {
        if ('button' in props) {
            return <CaptionWithButton caption={props.caption} button={props.button} />
        }
        return <Caption caption={props.caption} />
    }

    return <LoadingSpinner />
}

const SplashScreen: FunctionComponent<SplashScreenProps> = ({
    logoType,
    ...rest
}): ReactElement => (
    <FlexingContainer backgroundColor="BLACK">
        <SplashScreenBackground logoType={logoType} />
        <FlexingContainer
            top={0}
            bottom={0}
            left={0}
            right={0}
            position="absolute"
            centerHorizontal
            centerVertical
        >
            <IndicatorComponent {...rest} />
        </FlexingContainer>
    </FlexingContainer>
)

export default SplashScreen
